import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { PlotFilterType } from '../components/PageConfigProvider/types/item';
import { FilterId } from '../filters/types/filters';

const items: TabContent['items'] = [
  {
    position: { x: 32, width: 16, y: 0, height: 18 },
    id: 'geography-overview-top-industries',
    title: 'Top {{segment}}',
    info: {
      text: 'Distribution of industries/companies in this geography',
    },
    plot: {
      chartType: 'bar',
      defaultMetricOptions: ['headcount'],
      dimensionSource: 'rics',
      alternateDimensionSource: ['company'],
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 7 }],
      hideOther: true,
    },
  },
  {
    position: { x: 32, width: 16, y: 18, height: 18 },
    id: '3e8baa66-34ff-4050-ae40-f0ae298f43c7',
    title: 'Top Skills',
    info: {
      text: 'Distribution of skills in this geography',
    },
    plot: {
      chartType: 'bar',
      defaultMetricOptions: ['headcount'],
      dimensionSource: 'skills',
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 7 }],
      hideOther: true,
    },
  },
  {
    position: { x: 0, y: 0, width: 8, height: 9 },
    id: '60a0c0f4-fe76-4331-84bb-0836116d0196',
    title: 'Demand/Supply',
    plot: {
      chartType: 'gauge',
      gaugePrimaryText:
        '{{#if (gt (VALUE "demand_supply") 0)}}1:{{FORMAT (divide 1 (VALUE "demand_supply")) format=".1f"}}{{else}}0{{/if}}',
      gaugeSubText:
        '{{FORMAT (VALUE "postings_active") format=","}} postings vs {{FORMAT (VALUE "headcount") format=","}} profiles',
      gaugeValue: '{{VALUE "demand_supply_percentile"}}',
    },
  },
  {
    position: { x: 8, y: 0, width: 8, height: 9 },
    id: 'a0740e6f-af3e-4c80-bab8-7bc21104b937',
    title: 'Wage Pressure',
    plot: {
      chartType: 'gauge',
      gaugePrimaryText:
        '{{#if (gt (VALUE "wage_pressure") 0)}}\n+{{/if}}{{FORMAT (VALUE "wage_pressure") format=".0%"}}',
      gaugePrimaryLabel: 'yoy',
      gaugeSubText:
        '{{FORMAT (VALUE "salary" timeAggregation="first") format="$"}} → {{FORMAT (VALUE "salary" timeAggregation="latest") format="$"}}',
      gaugeValue: '{{VALUE "wage_pressure_percentile"}}',
    },
  },
  {
    position: { x: 16, y: 0, width: 8, height: 9 },
    id: 'd42e9365-2b5b-444f-8a1c-c0ea286f239b',
    title: 'Time to Fill',
    plot: {
      chartType: 'gauge',
      gaugePrimaryText: '{{FORMAT (VALUE "time_to_fill") format="INTEGER"}}',
      gaugePrimaryLabel: 'days',
      gaugeSubText: '',
      gaugeValue: '{{VALUE "time_to_fill_percentile"}}',
    },
  },
  {
    position: { x: 24, y: 0, width: 8, height: 9 },
    id: '2ce592bd-9f00-46b8-9ecc-2ca9aab8473a',
    title: 'Market Tightness',
    plot: {
      chartType: 'gauge',
      gaugeValue: '{{VALUE "market_tightness"}}',
      gaugePrimaryText: '{{FORMAT (VALUE "market_tightness") format="%"}}',
    },
  },
  {
    position: { x: 0, width: 32, y: 9, height: 27 },
    id: '996e45fc-a682-4734-aad5-f8c2c934035e',
    title: ' ',
    plot: {
      defaultMetricOptions: ['headcount'],
      chartType: 'map',
    },
  },
];

const geographyOverviewTab: TabContent = {
  id: 'geography-overview',
  items,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  primaryFilter: {
    id: FilterId.GEOGRAPHY,
    selectionLimit: 1,
    selectionDefault: 1,
  },
  secondaryFilters: [
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.COMPANY,
    FilterId.CONTINGENT_WORKERS,
    FilterId.EDUCATION,
    FilterId.ETHNICITY,
    FilterId.GENDER,
    FilterId.TITLE,
    FilterId.KEYWORDS,
  ].map((id) => ({ id })),
  dateRangeDefault: 'last-year',
};

export const geographyOverview: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.GEOGRAPHY_OVERVIEW,
  revelioPageId: RevelioPageId.GEOGRAPHY_OVERVIEW,
  name: 'Overview',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'geography-overview',
      label: 'Overview',
      tabContent: geographyOverviewTab,
      isActive: true,
    },
  ],
};
